import { gql } from "@apollo/client";

/* TODO: this is a placeholder. need to implement once backend has completed this mutation. */
export const deleteContent = gql`
  mutation deleteContent($id: ID!) {
    deleteContent(id: $id)
  }
`;

